<template>
  <basic-card>
    <template slot="header">{{$t('administration.users')}}
      <context-help help-item-code="user-card-header"/>
    </template>
    <data-table
        :data="users"
        :configuration="usersTableConfig"
        @focusedChanged="handleFocusedChanged"
        @add="handleAddNew"
        @delete="handleDelete"
        component-id="users-list"
    >
      <slot/>
    </data-table>
  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import DataTable from "../components/table/DataTable";
import ContextHelp from "../components/help/ContextHelp";

export default {
  name: "UsersListCard",
  components: {ContextHelp, DataTable, BasicCard},
  props: {
    users: Array,
  },
  data: function () {
    return {
      items: [],
      usersTableConfig: {
        objectName: this.$t('users.objectName'),
        enableAdd: true,
        allowEdit: true,
        columns: [
          {
            caption: "",
            datum: d => d.blocked ? this.$t('users.blocked') : this.$t('users.active'),

          },
          {
            caption: "Id",
            datum: d => d.id.substr(0, 5)
          },
          {
            caption: this.$t('users.username'),
            datum: d => d.username
          },
          {
            caption: this.$t('users.role'),
            datum: d => d.role
          },
          {
            caption: this.$t('users.email'),
            datum: d => d.email
          }
        ]
      }
    }
  },
  methods: {
    handleFocusedChanged(focused) {
      this.$emit("focusedChanged", focused);
    },
    handleAddNew() {
      this.items = [];
      this.$emit("focusedChanged", {})
    },
    handleDelete(item) {
      this.$emit("delete", item);
    }
  }

}
</script>

<style scoped>

</style>